module.exports = __webpack_public_path__ + "media/honey-icons/icon-dimmer-b3eb9e38.svg";